import { Component, OnInit } from '@angular/core';

import { PosService } from './service/pos.service';
import { StringUtilsService } from 'app/shared/string-utils.service';
import { environment } from 'environments/environment';

@Component({
  selector: 'app-pos',
  templateUrl: './pos.component.html',
  styleUrls: ['./pos.component.scss']
})
export class PosComponent implements OnInit {

  carregandoCursosPos = true;
  cursosPosGraduacao = [];
  environment = environment;

  constructor(
    private posService: PosService,
    private stringUtils: StringUtilsService,
  ) {}

  ngOnInit() {
    this.getDataPos()
  }

  async getDataPos() {
    await this.posService.getCursosPosGraduacao()
      .then(cursos => {
        this.cursosPosGraduacao = cursos

        this.cursosPosGraduacao.map(curso => {
          const link = this.gerarLinkCurso(curso)
          return { ...curso, link }
        })
      })
      .catch((err) => console.error(err))

    this.carregandoCursosPos = false;
  }

  gerarLinkCurso(curso) {
    return `${curso.id}-${this.stringUtils.textoParaSlug(curso.nome)}`;
  }

}
